import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";
import CookieBanner from "@/components/CookieBanner";
import BookingModal from "@/components/BookingModal";
import RouteAnalytics from "@/components/RouteAnalytics";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { captureUtmFromUrl } from "@/utils/utm";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyReading from "@/pages/CaseStudyReading";
import Sustainability from "@/pages/Sustainability";
import Insights from "@/pages/Insights";
import Resources from "@/pages/Resources";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import ComplianceOs from "@/pages/ComplianceOs";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/auth/AuthContext";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicSite = ({ onBook }) => (
  <div className="min-h-screen bg-paper text-ink">
    <Header onBook={onBook} />
    <main>
      <Routes>
        <Route path="/" element={<Home onBook={onBook} />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail onBook={onBook} />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/case-studies/university-of-reading" element={<CaseStudyReading />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/compliance-os" element={<ComplianceOs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
    </main>
    <Footer />
    <FloatingWhatsapp />
    <CookieBanner />
  </div>
);

function App() {
  const { pathname, search } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    if (new URLSearchParams(search).get("book") === "1") setBookingOpen(true);
  }, [search]);

  // Capture UTM params from URL once on first mount
  useEffect(() => {
    captureUtmFromUrl();
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <ScrollTop />
        <RouteAnalytics />
        {isAdmin ? (
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        ) : (
          <>
            <PublicSite onBook={() => setBookingOpen(true)} />
            <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
            <ExitIntentPopup />
          </>
        )}
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
